const CompanyMixin = {
  methods: {
    getCompany() {
      const url = route("public.api.company.show");
      return axios.get(url);
    },
  },
};

export default CompanyMixin;
